var React = require('react');

function TelegramIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.353258 9.58992L4.96166 11.5654L6.74539 18.154C6.85952 18.576 7.30879 18.732 7.60699 18.4519L10.1758 16.0468C10.4451 15.7948 10.8286 15.7822 11.11 16.0168L15.7432 19.8803C16.0622 20.1466 16.5141 19.9458 16.5941 19.5031L19.9882 0.751874C20.0756 0.268259 19.6618 -0.135187 19.2609 0.0429145L0.347858 8.42275C-0.118874 8.6295 -0.114808 9.3885 0.353258 9.58992ZM6.45792 10.5138L15.4645 4.14269C15.6263 4.02852 15.7929 4.2799 15.6539 4.42799L8.22085 12.3637C7.95959 12.643 7.79105 13.0168 7.74332 13.4226L7.49012 15.5777C7.45659 15.8654 7.10466 15.894 7.03552 15.6155L6.06172 11.6856C5.95019 11.2373 6.11272 10.7585 6.45792 10.5138Z","fill":"currentColor"}));
}

TelegramIcon.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = TelegramIcon;

TelegramIcon.default = TelegramIcon;
